import { useCallback } from "react";

/**
 * Hook to prefetch routes on hover/touch for faster navigation
 * Note: React Router doesn't have built-in prefetching, so this is a no-op
 */
export function usePrefetchRoute() {
  const prefetchRoute = useCallback(
    (href: string) => {
      // Prefetching not available in React Router
      // This is kept for API compatibility but does nothing
    },
    []
  );

  return { prefetchRoute };
}
